import { render, staticRenderFns } from "./Profil.vue?vue&type=template&id=7dd9c2a6&"
import script from "./Profil.js?vue&type=script&lang=js&"
export * from "./Profil.js?vue&type=script&lang=js&"
import style0 from "./Profil.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports